/* TSC Sell / Buylist page app */
(function () {
  var app = document.getElementById("sell-app");
  if (!app) return;
  var WORKER = (app.getAttribute("data-worker") || "").replace(/\/$/, "");
  var $ = function (id) { return document.getElementById(id); };
  var fmt = function (n) { return n == null ? "—" : "$" + Number(n).toFixed(2); };
  var r2 = function (n) { return Math.round(n * 100) / 100; };

  var CFG = { cashPct: null, creditPct: null, minOffer: 1, identifyEnabled: false };
  var picked = null;        // {card, variant, graded, gradeCompany, grade, photo}
  var pendingPhoto = null;  // dataURL from the photo tab (attached to next added item)
  var scan = null;          // {condition, reasons[], confidence} from identify or /sell/grade
  var gradeState = "idle";  // idle | running | done | failed
  var cart = [];
  var payout = "cash";

  // ── talking to the worker ──────────────────────────────────────────
  // Every call here used to go straight to r.json(). The worker answers a refusal
  // with a JSON {error} body and a non-2xx status -- 429 when a visitor is going
  // too fast, 413 when a body is too big, 400 for bad input -- so a refusal parsed
  // cleanly as a success shape and then read as an empty result. A rate-limited
  // search rendered "no matches", which tells the customer the exact opposite of
  // what happened. jfetch turns a non-OK response into a rejection carrying the
  // worker's own sentence, which is already written to be read by a customer.
  function jfetch(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) {
          var e = new Error(j.error || ("The server said no (" + r.status + ")."));
          e.status = r.status;
          throw e;
        }
        return j;
      });
    });
  }

  // ── keeping a submission inside what the worker will accept ────────
  // A submission is a STACK of cards, and each card carries up to five photos at
  // roughly 250KB once base64'd, so a real buylist can be many megabytes. The
  // worker accepts 14MB; nothing here used to know that, so a customer with a
  // decent stack photographed every card, typed their name and email, pressed the
  // button and got "payload too large" -- at the end, with no way forward.
  //
  // So the photos are re-encoded smaller until the body fits. The cart itself is
  // never touched: the customer's own previews stay sharp, and a retry starts from
  // the originals rather than from something already squeezed twice.
  var BODY_BUDGET = 12 * 1024 * 1024;      // under the worker's 14MB, leaving headroom
  var SQUEEZE = [{ max: 900, q: 0.78 }, { max: 760, q: 0.68 }, { max: 640, q: 0.60 }];

  function reencode(dataUrl, max, q) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var sc = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement("canvas");
        c.width = Math.round(img.width * sc); c.height = Math.round(img.height * sc);
        c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
        resolve(c.toDataURL("image/jpeg", q));
      };
      // Better to send the original than to lose the shot: a photo that will not
      // decode here is still a photo the shop can look at.
      img.onerror = function () { resolve(dataUrl); };
      img.src = dataUrl;
    });
  }

  function submitBody(items, name, email) {
    return { contact: { name: name, email: email, phone: $("cPhone").value.trim() },
             payout: payout, items: items };
  }
  // Photos are base64 and the rest is ASCII, so string length is the byte count
  // for everything that actually weighs anything here.
  function bodyBytes(items, name, email) {
    return JSON.stringify(submitBody(items, name, email)).length;
  }
  function fitCount(items, name, email) {
    for (var n = items.length - 1; n >= 1; n--) {
      if (bodyBytes(items.slice(0, n), name, email) <= BODY_BUDGET) return n;
    }
    return 1;
  }

  function fitToBudget(name, email, onStatus) {
    var items = cart.map(function (i) {
      var c = Object.assign({}, i);
      delete c.image;                                  // the catalogue thumbnail, not a customer photo
      c.photos = (i.photos || []).slice();
      return c;
    });
    if (bodyBytes(items, name, email) <= BODY_BUDGET) return Promise.resolve({ items: items });

    var chain = Promise.resolve(items);
    SQUEEZE.forEach(function (step) {
      chain = chain.then(function (its) {
        if (bodyBytes(its, name, email) <= BODY_BUDGET) return its;
        onStatus("Preparing photos…");
        // Four at a time, not all of them. A forty-card stack is two hundred photos,
        // and decoding two hundred images into two hundred canvases at once is how you
        // kill the tab on the phone the customer just photographed the cards with --
        // which is the device this runs on almost every time.
        var queue = [];
        its.forEach(function (it) {
          it.photos.forEach(function (ph, n) { queue.push({ it: it, n: n, ph: ph }); });
        });
        var next = 0;
        function worker() {
          if (next >= queue.length) return Promise.resolve();
          var job = queue[next++];
          return reencode(job.ph, step.max, step.q).then(function (out) {
            job.it.photos[job.n] = out;
            return worker();
          });
        }
        var lanes = [];
        for (var w = 0; w < 4; w++) lanes.push(worker());
        return Promise.all(lanes).then(function () { return its; });
      });
    });

    return chain.then(function (its) {
      if (bodyBytes(its, name, email) <= BODY_BUDGET) return { items: its };
      // Last resort before giving up: drop the extra angles, keep the front and
      // back, which are the two shots the shop actually prices from.
      its.forEach(function (it) { if (it.photos.length > 2) it.photos = it.photos.slice(0, 2); });
      if (bodyBytes(its, name, email) <= BODY_BUDGET) return { items: its };
      return { items: its, tooMany: fitCount(its, name, email) };
    });
  }

  // ── config ──
  jfetch(WORKER + "/sell/config").then(function (c) {
    CFG = c;
    $("rateCash").textContent = c.cashPct + "%";
    $("rateCredit").textContent = c.creditPct + "%";
    $("sellRates").hidden = false;
    if (c.identifyEnabled) { $("tabPhoto").hidden = false; }
  }).catch(function () {});

  // ── tabs ──
  function tab(which) {
    $("tabSearch").classList.toggle("is-on", which === "search");
    $("tabPhoto").classList.toggle("is-on", which === "photo");
    $("paneSearch").hidden = which !== "search";
    $("panePhoto").hidden = which !== "photo";
  }
  $("cgToggle").addEventListener("click", function () {
    var g = $("cguide");
    g.hidden = !g.hidden;
    $("cgToggle").textContent = g.hidden ? "what do these mean?" : "hide guide";
  });
  $("tabSearch").addEventListener("click", function () { tab("search"); });
  $("tabPhoto").addEventListener("click", function () { tab("photo"); });

  // ── search ──
  function renderResults(cards, label) {
    $("picker").hidden = true;
    $("results").hidden = false;
    $("resultsLabel").textContent = label;
    var list = $("cardList");
    list.innerHTML = "";
    if (!cards.length) { list.innerHTML = '<p class="mute">No matches — try the card name plus its collector number.</p>'; return; }
    cards.forEach(function (c) {
      var best = c.variants.length ? c.variants.reduce(function (a, b) { return (b.price || 0) > (a.price || 0) ? b : a; }) : null;
      var btn = document.createElement("button");
      btn.type = "button"; btn.className = "cardopt";
      btn.innerHTML =
        (c.image ? '<img src="' + c.image + '" alt="" onerror="this.style.visibility=\'hidden\'">' : "<span></span>") +
        '<span><span class="co-name">' + esc(c.name) + '</span><br><span class="co-set">' +
        esc([c.set, c.number, c.rarity].filter(Boolean).join(" · ")) + "</span></span>" +
        '<span class="co-price">' + (best ? "mkt " + fmt(best.price) : "") + "</span>";
      btn.addEventListener("click", function () { pick(c); });
      list.appendChild(btn);
    });
  }
  function esc(s) { var d = document.createElement("i"); d.textContent = s == null ? "" : String(s); return d.innerHTML; }

  function doSearch() {
    var q = $("q").value.trim();
    if (!q) return;
    $("goSearch").disabled = true; $("goSearch").textContent = "Searching…";
    jfetch(WORKER + "/sell/search?q=" + encodeURIComponent(q))
      .then(function (j) { renderResults(j.cards || [], 'Matches for "' + q + '" — pick your exact card:'); })
      .catch(function (e) { renderResults([], e.message || ""); })
      .finally(function () { $("goSearch").disabled = false; $("goSearch").textContent = "Search"; });
  }
  $("goSearch").addEventListener("click", doSearch);
  $("q").addEventListener("keydown", function (e) { if (e.key === "Enter") doSearch(); });

  // ── photo → identify ──
  function shrink(file, max) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        var s = Math.min(1, max / Math.max(img.width, img.height));
        var c = document.createElement("canvas");
        c.width = Math.round(img.width * s); c.height = Math.round(img.height * s);
        c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        resolve(c.toDataURL("image/jpeg", 0.85));
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(new Error("unreadable image")); };
      img.src = url;
    });
  }
  $("file").addEventListener("change", function () {
    var f = this.files && this.files[0];
    if (!f) return;
    shrink(f, 1100).then(function (dataUrl) {
      pendingPhoto = dataUrl;
      $("photoImg").src = dataUrl;
      $("photoPrev").hidden = false;
    }).catch(function () { alert("Couldn't read that image — try a JPG or PNG."); });
  });
  // ── graded slab photo slots (front + back required) ──
  var gradePhotos = { front: null, back: null, label: null };
  var extraPhotos = { 1: null, 2: null };
  var gradeTries = 0;
  function setSlot(name, dataUrl) {
    gradePhotos[name] = dataUrl || null;
    var slot = document.querySelector('.gp-slot[data-slot="' + name + '"]');
    if (!slot) return;
    var img = slot.querySelector("img");
    if (dataUrl) { img.src = dataUrl; img.hidden = false; slot.classList.add("filled"); }
    else { img.hidden = true; img.removeAttribute("src"); slot.classList.remove("filled"); }
  }
  function resetSlots() {
    setSlot("front", null); setSlot("back", null); setSlot("label", null);
    extraPhotos = { 1: null, 2: null }; gradeTries = 0;
    var box = $("retakeBox");
    if (box) {
      box.hidden = true;
      Array.prototype.forEach.call(box.querySelectorAll(".retake-slot"), function (sl) {
        sl.classList.remove("filled");
        var img = sl.querySelector("img"); img.hidden = true; img.removeAttribute("src");
        sl.querySelector("input").value = "";
      });
      $("regrade").disabled = true;
      $("retakeNote").hidden = true;
    }
  }
  Array.prototype.forEach.call(document.querySelectorAll(".gp-slot input[type=file]"), function (inp) {
    inp.addEventListener("change", function () {
      var f = inp.files && inp.files[0];
      var name = inp.closest(".gp-slot").getAttribute("data-slot");
      if (!f) return;
      shrink(f, 1000).then(function (d) {
        setSlot(name, d);
        if (name === "front" && picked && !picked.graded && !scan) requestGrade(d);
        else refreshOffer();
      }).catch(function () { alert("Couldn't read that image — try a JPG or PNG."); });
    });
  });

  $("goIdentify").addEventListener("click", function () {
    if (!pendingPhoto) return;
    var b = $("goIdentify"); b.disabled = true; b.textContent = "Identifying…";
    jfetch(WORKER + "/sell/identify", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ imageBase64: pendingPhoto.split(",")[1], mime: "image/jpeg" }),
    }).then(function (j) {
      var g = j.guess || {};
      scan = g.condition ? { condition: g.condition, reasons: g.conditionReasons || [], confidence: g.conditionConfidence || "" } : null;
      if (g.graded) { $("isGraded").checked = true; }
      var label = g.name
        ? "We read: " + [g.name, g.set, g.number].filter(Boolean).join(" · ") + (g.graded ? " · " + (g.gradeCompany || "graded") + " " + (g.grade || "") : "") + " — pick the exact match:"
        : "Couldn't read the card — try the search tab.";
      renderResults(j.cards || [], label);
      if (g.graded && j.cards && j.cards.length) {
        // pre-fill grade fields for when they pick
        picked = picked || {};
        picked._pregrade = { co: g.gradeCompany || "PSA", num: g.grade || "" };
      }
    }).catch(function (e) { renderResults([], e.message || "Identify failed — try the search tab."); })
      .finally(function () { b.disabled = false; b.textContent = "Identify this card"; });
  });

  // ── pick a card → condition/printing → offer ──
  function pick(card) {
    var pre = picked && picked._pregrade;
    picked = { card: card, variant: null, graded: false, gradeCompany: "PSA", grade: "" };
    $("results").hidden = true;
    $("picker").hidden = false;
    $("pickImg").src = card.image || "";
    $("pickName").textContent = card.name;
    $("pickSet").textContent = [card.set, card.number, card.rarity].filter(Boolean).join(" · ");

    // condition chips: unique conditions from the live price data
    var conds = [];
    card.variants.forEach(function (v) { if (conds.indexOf(v.condition) === -1) conds.push(v.condition); });

    // the scan's verdict wins the default selection when that condition is priced
    var preferred = scan && conds.indexOf(scan.condition) >= 0 ? scan.condition : conds[0];
    var preferMint = !!(scan && /^mint$/i.test(scan.condition));

    var cc = $("condChips"); cc.innerHTML = "";
    function addChip(label, cls, onPick) {
      var btn = document.createElement("button");
      btn.type = "button"; btn.className = "chip" + (cls ? " " + cls : "");
      btn.innerHTML = label;
      btn.addEventListener("click", function () {
        Array.prototype.forEach.call(cc.querySelectorAll(".chip"), function (x) { x.classList.remove("is-on"); });
        btn.classList.add("is-on");
        onPick();
      });
      cc.appendChild(btn);
      return btn;
    }
    // Mint sits above Near Mint; the market prices no higher, so it quotes at NM and we say so.
    var hasNM = conds.indexOf("Near Mint") >= 0;
    if (hasNM) addChip("Mint", "chip-mint", function () { $("isGraded").checked = false; setCondition("Mint"); });
    conds.forEach(function (cond) {
      addChip(cond, cond === preferred ? "is-on" : "", function () {
        $("isGraded").checked = false; setCondition(cond);
      });
    });
    addChip("Graded slab", "chip-slab", function () {
      $("isGraded").checked = true;
      picked.mint = false; $("mintNote").hidden = true;
      gradedToggle();
    });

    // grading lifecycle: identify already graded it, otherwise wait for a photo
    $("scanAgree").checked = false;
    $("ovAgree").checked = false;
    $("attestAgree").checked = false;
    $("slabAgree").checked = false;
    $("slabBox").hidden = true;
    $("itemNote").value = "";
    gradeState = scan ? "done" : "idle";
    renderScanBox();

    if (preferMint && hasNM) {
      var mintChip = cc.querySelector(".chip-mint");
      if (mintChip) {
        Array.prototype.forEach.call(cc.querySelectorAll(".chip"), function (x) { x.classList.remove("is-on"); });
        mintChip.classList.add("is-on");
        setCondition("Mint");
      } else if (conds.length) { setCondition(preferred); }
    } else if (conds.length) { setCondition(preferred); }

    $("isGraded").checked = false;
    resetSlots();
    if (pendingPhoto) { setSlot("front", pendingPhoto); pendingPhoto = null; $("photoPrev").hidden = true; $("file").value = ""; }
    if (pre) {
      $("isGraded").checked = true;
      $("gradeCo").value = ["PSA","BGS","CGC"].indexOf(pre.co) >= 0 ? pre.co : "Other";
      $("gradeNum").value = pre.num;
    }
    gradedToggle();
    $("picker").scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
  function setCondition(cond) {
    picked.condition = cond;
    picked.mint = /^mint$/i.test(cond);
    $("mintNote").hidden = !picked.mint;
    syncConditionAgreement();
    var priceCond = picked.mint ? "Near Mint" : cond;
    var vs = picked.card.variants.filter(function (v) { return v.condition === priceCond; });
    var prints = [];
    vs.forEach(function (v) { if (prints.indexOf(v.printing) === -1) prints.push(v.printing); });
    var pf = $("printField"), pc = $("printChips");
    if (prints.length > 1) {
      pf.hidden = false; pc.innerHTML = "";
      prints.forEach(function (pr, i) {
        var btn = document.createElement("button");
        btn.type = "button"; btn.className = "chip" + (i === 0 ? " is-on" : "");
        btn.textContent = pr || "Normal";
        btn.addEventListener("click", function () {
          pc.querySelectorAll(".chip").forEach(function (x) { x.classList.remove("is-on"); });
          btn.classList.add("is-on");
          setVariant(vs.find(function (v) { return v.printing === pr; }));
        });
        pc.appendChild(btn);
      });
    } else { pf.hidden = true; }
    setVariant(vs[0]);
  }
  function setVariant(v) {
    picked.variant = v || null;
    refreshOffer();
  }
  function requestGrade(dataUrl) {
    if (!CFG.identifyEnabled) { gradeState = "failed"; syncConditionAgreement(); return; }
    gradeState = "running";
    syncConditionAgreement();
    jfetch(WORKER + "/sell/grade", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        imageBase64: dataUrl.split(",")[1], mime: "image/jpeg",
        cardName: picked && picked.card ? picked.card.name : "",
      }),
    }).then(function (j) {
      if (!j || !j.condition) throw new Error(j && j.error ? j.error : "no grade");
      scan = { condition: j.condition, reasons: j.conditionReasons || [], confidence: j.conditionConfidence || "",
               retake: !!j.retake, retakeHint: j.retakeHint || "" };
      gradeState = "done";
      renderScanBox();
      renderRetake();
      // the grade drives the condition selection when that tier is priced
      var cc = $("condChips");
      var match = Array.prototype.filter.call(cc.querySelectorAll(".chip"), function (b) {
        return b.textContent.trim() === scan.condition;
      })[0];
      if (match) {
        Array.prototype.forEach.call(cc.querySelectorAll(".chip"), function (x) { x.classList.remove("is-on"); });
        match.classList.add("is-on");
        setCondition(scan.condition);
      } else { syncConditionAgreement(); }
    }).catch(function () { gradeState = "failed"; syncConditionAgreement(); });
  }

  function renderRetake() {
    var box = $("retakeBox");
    if (!box) return;
    var need = !!(scan && scan.retake && picked && !picked.graded);
    box.hidden = !need;
    if (!need) return;
    $("retakeHint").textContent = scan.retakeHint
      ? "Tip: " + scan.retakeHint + "."
      : "Add one or two more photos — brighter, straight on, out of the sleeve.";
    $("retakeNote").hidden = gradeTries < 2;   // after a second miss, let them proceed with a flag
  }
  Array.prototype.forEach.call(document.querySelectorAll(".retake-slot input"), function (inp) {
    inp.addEventListener("change", function () {
      var f = inp.files && inp.files[0];
      if (!f) return;
      var n = inp.getAttribute("data-extra");
      shrink(f, 1000).then(function (d) {
        extraPhotos[n] = d;
        var slot = inp.closest(".retake-slot");
        var img = slot.querySelector("img");
        img.src = d; img.hidden = false; slot.classList.add("filled");
        $("regrade").disabled = !(extraPhotos[1] || extraPhotos[2]);
      }).catch(function () { alert("Couldn't read that image — try a JPG or PNG."); });
    });
  });
  var regradeBtn = $("regrade");
  if (regradeBtn) regradeBtn.addEventListener("click", function () {
    if (!gradePhotos.front) return;
    gradeTries++;
    regradeBtn.disabled = true; regradeBtn.textContent = "Checking…";
    jfetch(WORKER + "/sell/grade", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        imageBase64: gradePhotos.front.split(",")[1], mime: "image/jpeg",
        cardName: picked && picked.card ? picked.card.name : "",
        extraImagesBase64: [extraPhotos[1], extraPhotos[2]].filter(Boolean).map(function (d) { return d.split(",")[1]; }),
      }),
    }).then(function (j) {
      if (!j || !j.condition) throw new Error("no grade");
      scan = { condition: j.condition, reasons: j.conditionReasons || [], confidence: j.conditionConfidence || "",
               retake: !!j.retake, retakeHint: j.retakeHint || "" };
      renderScanBox(); renderRetake();
      var cc = $("condChips");
      var match = Array.prototype.filter.call(cc.querySelectorAll(".chip"), function (b) {
        return b.textContent.trim() === scan.condition;
      })[0];
      if (match) {
        Array.prototype.forEach.call(cc.querySelectorAll(".chip"), function (x) { x.classList.remove("is-on"); });
        match.classList.add("is-on");
        setCondition(scan.condition);
      } else { syncConditionAgreement(); }
    }).catch(function () {})
      .finally(function () { regradeBtn.disabled = false; regradeBtn.textContent = "Re-check with these photos"; });
  });

  function renderScanBox() {
    if (!scan) { $("scanBox").hidden = true; return; }
    $("scanCond").textContent = scan.condition;
    $("scanConf").innerHTML = scan.confidence
      ? '<span class="scan-conf">' + esc(scan.confidence) + " confidence</span>" : "";
    if (scan.reasons && scan.reasons.length) {
      $("scanWhy").textContent = "What we spotted: " + scan.reasons.join(", ") + ".";
      $("scanWhy").hidden = false;
    } else { $("scanWhy").hidden = true; }
  }

  function syncConditionAgreement() {
    if (!picked) return;
    var graded = picked.graded;
    var differs = !!(scan && picked.condition && scan.condition !== picked.condition);
    $("scanning").hidden = graded || gradeState !== "running";
    $("gradeWait").hidden = graded || gradeState !== "idle" || !!scan;
    $("attestBox").hidden = graded || gradeState !== "failed";
    $("scanBox").hidden = graded || !scan || differs;
    $("overrideBox").hidden = graded || !differs;
    if (differs) {
      $("ovPicked").textContent = picked.condition;
      $("ovScan").textContent = scan.condition;
    }
    refreshOffer();
  }
  function conditionBlocked() {
    if (!picked || picked.graded) return false;
    if (gradeState === "running") return true;                 // wait for the grade
    if (gradeState === "failed") return !$("attestAgree").checked;
    if (!scan) return true;                                    // photo not graded yet
    var differs = !!(picked.condition && scan.condition !== picked.condition);
    return differs ? !$("ovAgree").checked : !$("scanAgree").checked;
  }
  $("scanAgree").addEventListener("change", refreshOffer);
  $("ovAgree").addEventListener("change", refreshOffer);
  $("attestAgree").addEventListener("change", refreshOffer);

  function slabMult() {
    var co = ($("gradeCo").value || "OTHER").toUpperCase();
    if (["PSA", "BGS", "CGC"].indexOf(co) < 0) co = "OTHER";
    var g = ($("gradeNum").value || "").trim();
    var table = CFG.gradeMult || {};
    if (table[co + " " + g] != null) return Number(table[co + " " + g]);
    var num = parseFloat(g);
    if (isFinite(num)) {                                   // nearest lower listed rung
      var rungs = Object.keys(table).filter(function (k) { return k.indexOf(co + " ") === 0; })
        .map(function (k) { return { k: k, n: parseFloat(k.slice(co.length + 1)) }; })
        .filter(function (x) { return isFinite(x.n); }).sort(function (a, b) { return a.n - b.n; });
      var pick = null;
      rungs.forEach(function (r) { if (r.n <= num) pick = r; });
      if (pick) return Number(table[pick.k]);
      if (rungs.length) return Number(table[rungs[0].k]);
    }
    return Number(table.DEFAULT || 0);
  }

  function slabQuote() {
    if (!picked || !picked.graded) return null;
    if (CFG.gradedLive === false) return null;
    var nm = picked.card.variants.filter(function (v) { return v.condition === "Near Mint"; })[0];
    if (!nm || nm.price == null) return null;
    var m = slabMult();
    if (!m) return null;
    var mid = Number(nm.price) * m;
    var sp = (CFG.gradeSpread == null ? 30 : CFG.gradeSpread) / 100;
    var pct = (payout === "credit" ? CFG.creditPct : CFG.cashPct) / 100;
    return { mult: m, nm: Number(nm.price),
             low: r2(mid * (1 - sp) * pct), high: r2(mid * (1 + sp) * pct) };
  }

  function refreshSlab() {
    var q = slabQuote();
    var box = $("slabBox");
    if (!picked || !picked.graded || !q) { box.hidden = true; return; }
    $("slabRange").textContent = fmt(q.low) + " – " + fmt(q.high);
    $("slabRangeMode").textContent = payout === "credit" ? "in store credit" : "in cash";
    $("offerBox").hidden = true;
    box.hidden = false;
    refreshOffer();
  }
  $("gradeCo").addEventListener("change", refreshSlab);
  $("gradeNum").addEventListener("input", refreshSlab);
  $("slabAgree").addEventListener("change", refreshOffer);

  function gradedToggle() {
    var on = $("isGraded").checked;
    if (on) { $("mintNote").hidden = true; }
    picked && (picked.graded = on);
    $("gradeFields").hidden = !on;
    $("gpLabelSlot").hidden = !on;
    $("gpReq").textContent = on ? "front & back required" : "front required";
    $("gpBackOpt").hidden = on;
    $("gpBackSlot").classList.toggle("gp-opt", !on);
    if (!on) { $("slabBox").hidden = true; }
    refreshOffer();
    if (on) refreshSlab();
  }
  $("isGraded").addEventListener("change", gradedToggle);

  function refreshOffer() {
    if (!picked) return;
    var box = $("offerBox"), warn = $("minWarn");
    if (picked.graded || !picked.variant || picked.variant.price == null) {
      box.hidden = true; warn.hidden = true;
      if (picked.graded) {
        var q = slabQuote();
        var photosOk = !!(gradePhotos.front && gradePhotos.back);
        var attested = $("slabAgree").checked;
        $("addItem").disabled = !(photosOk && attested);
        $("addItem").textContent = !photosOk ? "Add front & back photos to continue"
          : !attested ? "Confirm the slab is as graded to continue"
          : "Add — we'll email your firm quote";
      } else {
        var okRaw = !!picked.variant && !!gradePhotos.front && !conditionBlocked();
        $("addItem").disabled = !okRaw;
        $("addItem").textContent = !gradePhotos.front ? "Add a photo of your card to continue"
          : gradeState === "running" ? "Grading your photo…"
          : conditionBlocked() ? "Confirm the condition above to continue" : "Add to my sale";
      }
      return;
    }
    var m = Number(picked.variant.price);
    var cash = r2(m * CFG.cashPct / 100);
    var credit = r2(m * CFG.creditPct / 100);
    $("offMarket").textContent = fmt(m);
    $("offCash").textContent = fmt(cash);
    $("offCredit").textContent = fmt(credit);
    box.hidden = false;
    var below = cash < CFG.minOffer;
    warn.hidden = !below;
    var needPhoto = !gradePhotos.front;
    var needAgree = conditionBlocked();
    $("estFlag").hidden = !(needPhoto || needAgree) || below;
    $("addItem").disabled = below || needPhoto || needAgree;
    $("addItem").textContent = below ? "Add to my sale"
      : needPhoto ? "Add a photo of your card to continue"
      : gradeState === "running" ? "Grading your photo…"
      : needAgree ? "Confirm the condition above to continue" : "Add to my sale";
  }
  $("pickBack").addEventListener("click", function () { $("picker").hidden = true; $("results").hidden = false; });

  // ── cart ──
  $("addItem").addEventListener("click", function () {
    if (!picked || !picked.card) return;
    if (!gradePhotos.front) return;
    if (picked.graded && !gradePhotos.back) return;
    var c = picked.card, v = picked.variant;
    var m = !picked.graded && v ? Number(v.price) : null;
    cart.push({
      name: c.name, set: c.set, game: c.game, number: c.number, tcgplayerId: c.tcgplayerId,
      image: c.image,
      graded: picked.graded,
      gradeCompany: picked.graded ? $("gradeCo").value : null,
      grade: picked.graded ? $("gradeNum").value.trim() : null,
      variantId: v ? v.variantId : null,
      condition: picked.mint ? "Mint" : (v ? v.condition : ""),
      printing: v ? v.printing : "",
      market: picked.graded ? null : m,
      cash: picked.graded ? null : (m != null ? r2(m * CFG.cashPct / 100) : null),
      credit: picked.graded ? null : (m != null ? r2(m * CFG.creditPct / 100) : null),
      rangeLow: picked.graded ? (slabQuote() || {}).low : undefined,
      rangeHigh: picked.graded ? (slabQuote() || {}).high : undefined,
      slabAttested: picked.graded ? $("slabAgree").checked : undefined,
      photo: null,
      photos: [gradePhotos.front, gradePhotos.back, picked.graded ? gradePhotos.label : null,
               extraPhotos[1], extraPhotos[2]].filter(Boolean),
      photoUnclear: !!(scan && scan.retake) || undefined,
      note: $("itemNote").value.trim(),
      scanCondition: scan ? scan.condition : null,
      scanConfidence: scan ? scan.confidence : null,
      scanReasons: scan ? scan.reasons : [],
      conditionAgreed: $("scanAgree").checked || $("ovAgree").checked || $("attestAgree").checked,
      conditionOverride: !!(scan && v && scan.condition !== v.condition),
    });
    resetSlots();
    pendingPhoto = null; $("photoPrev").hidden = true; $("file").value = "";
    scan = null; gradeState = "idle";
    $("scanBox").hidden = true; $("overrideBox").hidden = true;
    $("attestBox").hidden = true; $("gradeWait").hidden = true; $("scanning").hidden = true;
    $("estFlag").hidden = true; $("itemNote").value = "";
    picked = null; $("picker").hidden = true; $("q").value = "";
    renderCart();
  });

  function renderCart() {
    var rows = $("cartRows");
    rows.innerHTML = "";
    $("cartEmpty").hidden = cart.length > 0;
    cart.forEach(function (it, i) {
      var row = document.createElement("div");
      row.className = "cartrow";
      var off = it.graded || it.market == null ? null : (payout === "credit" ? it.credit : it.cash);
      row.innerHTML =
        (it.image ? '<img src="' + it.image + '" alt="" onerror="this.style.visibility=\'hidden\'">' : "<span></span>") +
        '<span><span class="cr-name">' + esc(it.name) + '</span><br><span class="cr-sub">' +
        esc([it.set, it.graded ? (it.gradeCompany || "Graded") + " " + (it.grade || "") : it.condition,
             it.printing && !/normal/i.test(it.printing) ? it.printing : ""].filter(Boolean).join(" · ")) + "</span></span>" +
        (off != null ? '<span class="cr-off">' + fmt(off) +
          (it.conditionOverride ? '<br><span class="cr-flag">your grade</span>' : "") + "</span>"
          : (it.rangeLow != null
              ? '<span class="cr-rev">' + fmt(it.rangeLow) + "–" + fmt(it.rangeHigh) + '<br><span class="cr-flag">quote by email</span></span>'
              : '<span class="cr-rev">our team prices</span>')) +
        '<button class="x" type="button" aria-label="Remove">×</button>';
      row.querySelector(".x").addEventListener("click", function () { cart.splice(i, 1); renderCart(); });
      rows.appendChild(row);
    });
    var totCash = cart.reduce(function (a, i) { return a + (i.cash || 0); }, 0);
    var totCredit = cart.reduce(function (a, i) { return a + (i.credit || 0); }, 0);
    $("totCash").textContent = fmt(Math.round(totCash * 100) / 100);
    $("totCredit").textContent = fmt(Math.round(totCredit * 100) / 100);
    // phone app bar mirrors the running offer
    var bar = $("sellBar");
    if (bar) {
      bar.hidden = cart.length === 0;
      $("sellBarLbl").textContent = payout === "credit" ? "Store credit" : "Cash offer";
      $("sellBarAmt").textContent = fmt(Math.round((payout === "credit" ? totCredit : totCash) * 100) / 100);
      $("sellBarCount").textContent = cart.length + (cart.length === 1 ? " card" : " cards");
    }
    $("payoutBox").hidden = cart.length === 0;
    $("contactBox").hidden = cart.length === 0;
    $("reviewNote").hidden = !cart.some(function (i) { return i.graded || i.market == null; });
  }
  $("payCash").addEventListener("click", function () { payout = "cash"; payChips(); renderCart(); refreshSlab(); });
  $("payCredit").addEventListener("click", function () { payout = "credit"; payChips(); renderCart(); refreshSlab(); });
  function payChips() {
    $("payCash").classList.toggle("is-on", payout === "cash");
    $("payCredit").classList.toggle("is-on", payout === "credit");
  }

  // ── submit ──
  var DONE = null;
  $("submitSale").addEventListener("click", function () {
    var name = $("cName").value.trim(), email = $("cEmail").value.trim();
    if (!name || !/.+@.+\..+/.test(email)) { alert("Please enter your name and a valid email."); return; }
    var b = $("submitSale"); b.disabled = true; b.textContent = "Submitting…";
    fitToBudget(name, email, function (t) { b.textContent = t; }).then(function (fit) {
      if (fit.tooMany) {
        alert("That is more photos than we can send in one go.\n\nSubmit the first "
          + fit.tooMany + " card" + (fit.tooMany === 1 ? "" : "s") + " now, then start a second "
          + "buylist with the rest — or call us on 324-200-8945 and we will take the whole "
          + "lot over the phone.");
        return null;
      }
      b.textContent = "Submitting…";
      return jfetch(WORKER + "/sell/submit", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify(submitBody(fit.items, name, email)),
      });
    }).then(function (j) {
      if (!j) return;                    // the oversized case already spoke to the customer
      if (!j.id) throw new Error(j.error || "submit failed");
      DONE = { res: j, name: name, email: email };
      $("doneId").textContent = j.id;
      $("donePayout").textContent = payout === "credit"
        ? "store credit (" + fmt(j.totals.credit) + " estimated)"
        : "cash (" + fmt(j.totals.cash) + " estimated)";
      $("doneSlabs").hidden = !cart.some(function (i) { return i.graded; });
      $("doneBox").hidden = false;
      $("doneBox").scrollIntoView({ behavior: "smooth" });
    }).catch(function (e) { alert("Something went wrong: " + e.message); })
      .finally(function () { b.disabled = false; b.textContent = "Get my offer & shipping label"; });
  });

  // ── print label / receipt ──
  function printHTML(html) {
    var area = document.getElementById("tscPrint");
    area.innerHTML = html; area.hidden = false;
    window.print();
  }
  $("printLabel").addEventListener("click", function () {
    if (!DONE) return;
    var s = DONE.res.shipTo;
    printHTML(
      '<div class="plabel"><div style="font-size:12px">FROM: ' + esc(DONE.name) + " · " + esc(DONE.email) + "</div><hr>" +
      "<h2>SHIP TO:</h2><div class='big'>" + esc(s.name) + "</div>" +
      "<div class='big'>" + esc(s.address1) + "</div>" +
      "<div class='big'>" + esc(s.city + ", " + s.state + " " + s.zip) + "</div><hr>" +
      "<div class='big'>REF: " + esc(DONE.res.id) + "</div>" +
      "<div style='font-size:12px;margin-top:6px'>Write this reference on a note inside the package. Sleeve every card. Ship with tracking.</div></div>"
    );
  });
  $("printReceipt").addEventListener("click", function () {
    if (!DONE) return;
    var rows = cart.map(function (i) {
      var off = i.graded || i.market == null ? "team review" : fmt(payout === "credit" ? i.credit : i.cash);
      return "<tr><td>" + esc(i.name) + (i.set ? " — " + esc(i.set) : "") + "</td><td>" +
        esc(i.graded ? (i.gradeCompany || "Graded") + " " + (i.grade || "") : i.condition) + "</td><td>" + off + "</td></tr>";
    }).join("");
    printHTML(
      "<h2>TCG Supply Co — Buylist receipt</h2>" +
      "<p>" + esc(DONE.res.id) + " · " + new Date().toLocaleString() + " · " + esc(DONE.name) + "</p>" +
      "<table><tr><th>Card</th><th>Condition</th><th>Offer</th></tr>" + rows + "</table>" +
      "<h3>Estimated total (" + payout + "): " + fmt(DONE.res.totals[payout]) + "</h3>" +
      "<p style='font-size:12px'>" + esc(DONE.res.note) + "</p>" +
      "<p style='font-size:12px'>TCG Supply Co · 1871 Wells Rd, Suite 17 · Orange Park, FL 32073 · 324-200-8945</p>"
    );
  });
  window.addEventListener("afterprint", function () { document.getElementById("tscPrint").hidden = true; });
})();

/* showcase card tilt + shine — same model as the homepage holo card */
(function () {
  var cards = document.querySelectorAll(".sell .scard");
  if (!cards.length) return;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  Array.prototype.forEach.call(cards, function (card) {
    var raf = null;
    function move(e) {
      var r = card.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width;
      var y = (e.clientY - r.top) / r.height;
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        card.style.setProperty("--ry", ((x - 0.5) * 26).toFixed(2) + "deg");
        card.style.setProperty("--rx", ((0.5 - y) * 26).toFixed(2) + "deg");
        card.style.setProperty("--mx", (x * 100).toFixed(1) + "%");
        card.style.setProperty("--my", (y * 100).toFixed(1) + "%");
        card.style.setProperty("--holo-angle", (100 + (x - 0.5) * 70 + (y - 0.5) * 30).toFixed(1) + "deg");
      });
    }
    function rest() {
      card.classList.remove("is-live");
      card.style.setProperty("--rx", "0deg"); card.style.setProperty("--ry", "0deg");
      card.style.setProperty("--mx", "50%");  card.style.setProperty("--my", "50%");
      card.style.setProperty("--holo-angle", "112deg");
    }
    // pointer events cover mouse AND touch, which is what makes the homepage card feel right on a phone
    card.addEventListener("pointerenter", function () { card.classList.add("is-live"); });
    card.addEventListener("pointerdown", function () { card.classList.add("is-live"); });
    card.addEventListener("pointermove", move);
    card.addEventListener("pointerleave", rest);
    card.addEventListener("pointercancel", rest);
    card.addEventListener("pointerup", function () { setTimeout(rest, 900); });
  });
})();

/* phone app bar: jump to the review panel */
(function () {
  var go = document.getElementById("sellBarGo");
  if (!go) return;
  go.addEventListener("click", function () {
    var cartPanel = document.getElementById("cartRows");
    if (cartPanel) cartPanel.closest(".panel").scrollIntoView({ behavior: "smooth", block: "start" });
  });
})();
